<template>
  <div id="app">
    <Header
      v-if="
        [
          'UserRegister',
          'Userlogin',
          'RegisterForm',
          'NewClubForm',
          'ResetPassword',
          'ChangePasswordWithToken'
        ].indexOf($route.name) == -1
      "
      :key="`h-${$route.path}`"
    ></Header>
    <router-view :key="$route.path" />
    <Footer
      v-if="
        [
          'UserRegister',
          'Userlogin',
          'RegisterForm',
          'NewClubForm',
          'ResetPassword',
          'page_not_found',
          'forbidden',
          'internal-server-error',
          'ChangePasswordWithToken'
        ].indexOf($route.name) == -1
      "
    ></Footer>
  </div>
</template>

<script>
import Footer from "./components/Layouts/Footer.vue";
import Header from "./components/Layouts/Header.vue";

const CHAT_STORE_KEY = "chatStore";
const NOTIFICATION_STORE = "notificationStore";

const USER_PERMISSION_TO_UNIQUE_SLUG = {
  collegeHeadCoach: "collegeCoach",
  player: "player",
  clubHeadCoach: "clubCoach",
  premiumclubHeadCoach: "clubCoach",
  collegeNormalCoach: "collegeCoach",
  collegeProfileMaintainer: "collegeCoach"
};

export default {
  name: "App",
  components: { Footer, Header },
  methods: {
    async updateCoachSettings(slug) {
      await this.$store.dispatch('userStore/setUser', slug)
      localStorage.setItem("user-free-profile-quota", false);
      localStorage.setItem("user-name", JSON.stringify(slug.coachname));
      localStorage.setItem("user-id", JSON.stringify(slug.coachId._id));
      localStorage.setItem('user-permissions',JSON.stringify(slug.coachId.role))
      localStorage.setItem("profile-id", slug._id);
      window.location.replace(`/${slug._id}/college_profile/summary`);
    },
    async handleReceiverEmit(chat, notificationCount) {
       await this.$store.dispatch(
        `${CHAT_STORE_KEY}/setNotificationCount`,
        notificationCount
      );
    },
    async updateSystemNotification(slug) {
      if (
        USER_PERMISSION_TO_UNIQUE_SLUG[
          JSON.parse(localStorage["user-permissions"]).toLowerCase()
        ] !== slug.grpType.toLowerCase()
      ) {
        return;
      }
      if (slug) {
        await this.$store.dispatch(
          `${NOTIFICATION_STORE}/updateNotificationList`,
          slug
        );
        this.$notification.success({
          description: "You have received a new upgrade notification."
        });
      }
    },
    async handleNewMessage() {
      await this.$store.dispatch(`${CHAT_STORE_KEY}/getContactList`, {
        page: 10
      });
    },
    async updateNotification(slug) {
      if (
        USER_PERMISSION_TO_UNIQUE_SLUG[
          JSON.parse(localStorage["user-permissions"])
        ] !== slug.grpType
      ) {
        return;
      }
      if (slug) {
        await this.$store.dispatch(
          `${NOTIFICATION_STORE}/updateNotificationList`,
          slug
        );
        this.$notification.success({
          description: "You have received a new notification."
        });
      }
    }
  },
  watch: {
    "$route.params": {
      deep: true,
      immediate: true,
      handler: async function(newVal, oldVal) {
        if (
          (oldVal && oldVal.profileId) !== (newVal && newVal.profileId) &&
          Boolean(newVal.profileId)
        ) {
          await this.$store.dispatch(`${CHAT_STORE_KEY}/getContactList`, {
            page: 10
          });
          let user_id = localStorage.getItem('user-id');
          await this.chatSockets.emit("set-user-data", {profileId:newVal.profileId, userId:user_id.replaceAll('"', '')});
          this.chatSockets.addEvents([
            { name: "updatedContact", handler: this.handleNewMessage },
            { name: "player", handler: this.updateNotification },
            { name: "clubCoach", handler: this.updateNotification },
            { name: "collegeCoach", handler: this.updateNotification },
            { name: "renewal", handler: this.updateSystemNotification },
            { name: "Renewal", handler: this.updateSystemNotification },
            { name: 'updateRole', handler: this.updateCoachSettings },
            { name: "receiverEmit", handler: this.handleReceiverEmit },
          ]);
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
